import { STEP } from '../constants';

export default {
  widgets: {
    applicationCompletionFlow: {
      title: 'Rasmiylashtirish',
      steps: {
        [STEP.FILL_MARKING]: 'Mahsulotlarni markirovkalash',
        [STEP.FILL_IMEIS]: 'Mahsulot IMEI raqamlari',
        [STEP.SELL_TO_ALIF]: 'Alifga sotish',
        [STEP.COMPLETION]: 'Rasmiylashtirish',
        [STEP.SEND_FOR_DELIVERY]: 'Yetkazib berishga topshirish',
      },
      alifDelivery: 'Alif Delivery orqali yetkazib berish',
      createAlifDeliveryLink: 'Yetkazib berishni yaratish',
      edit: 'Tahrirlash',
      cancel: 'Bekor qilish',
    },
  },
};
